// @ts-check

import { dateToString } from '@/helpers/dates'
import { i18n } from '@/i18n'

export function present({ disabledFrom, disabledUntil }) {
  if (!disabledFrom || !disabledUntil) {
    return {}
  }
  const from = dateToString(disabledUntil)
  const to = dateToString(disabledFrom)

  return {
    paymentInfo: i18n.global.t('document_period_payment_date_info', {
      from,
      to
    }),
    expenseInfo: i18n.global.t('document_period_expense_date_info', {
      from,
      to
    })
  }
}

export default {}
